import { TCourse, TTask } from "../../types";
import { MathJaxOutput } from "../../components/mathJax/MathJaxOutput";
import { Fragment } from "react/jsx-runtime";
import { QuestionImage } from "../../components/task/QuestionImage";

export function TaskListForPrinting(props: {
  tasks: TTask[];
  course: TCourse;
}) {
  const { tasks, course } = props;
  let x = 1;
  tasks.forEach((t, i) => {
    if (!t.rootId) {
      t.displayIndex = i + 1;
    }
  });
  return (
    <div>
      {tasks.map((task) => (
        <div className="TaskItemLayerContainerForPrint" key={(x++).toString()}>
          <h1
            style={{
              fontSize: "26px",
              lineHeight: "27px",
              fontFamily: "Montserrat",
              fontWeight: "450",
            }}
          >
            {task.displayIndex! > 9
              ? !task.rootId
                ? task.displayIndex
                : ""
              : !task.rootId
                ? "0" + task.displayIndex
                : ""}
          </h1>

          <div
            style={{
              padding: "0.15rem",
              fontWeight: "500",
              wordWrap: "break-word",
            }}
          >
            <QuestionImage task={task} maxWidth={300} maxHeight={400} />
            <MathJaxOutput text={task.question} />
            <div className="TaskIdForPrint">id:{task.id}</div>

            {task.subTasks ? (
              task.subTasks.map((subtask) => (
                <Fragment key={subtask.id}>
                  <div className="SubTasksForPrint">
                    <QuestionImage task={task} maxWidth={300} maxHeight={400} />
                    <MathJaxOutput text={subtask.question} />
                    <div className="TaskIdForPrint">id:{subtask.id}</div>
                  </div>
                </Fragment>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
